<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title title="Remove user?" />
    <div v-emoji="copy" class="t" />
    <donut-modal-sections-actions v-bind="actionsArgs" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, getters } = useStore();

  const copy = computed(() => 'Are you sure you want to remove this person and their wallet? While deactivated, they won\'t '
      + `be able to send, receive, or redeem their ${getters['pointsConfig/pointsPhraseFromConfig']({})}.`);

  const actionsArgs = computed(() => ({
      buttonText: 'Remove user',
      saveAction: 'pointsLeaderboard/updateWalletState',
      saveArgs: { user: state.modal.data.user, value: 'inactive' },
    }));
</script>
